<template>
    <tbody>
        <tr class="no-print">
            <td width="100">
                <strong>{{ reserva.data | date("dd/LL/yyyy") }}</strong>
            </td>
            <td>
                {{ reserva.ambiente.titulo }}
                <br />
                {{ reserva.titulo_unidade }}


                <strong v-if="reserva.turno">
                    <br />{{ reserva.turno.titulo }}
                </strong>

                <div v-if="taxas.length != 0">
                    <span>&nbsp;</span>
                    <table>
                        <thead>
                            <tr>
                                <th align="left">Taxa</th>
                                <th width="150">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="taxa in taxas">
                                <td>{{ taxa.titulo }}</td>
                                <td align="center">R$ {{ taxa.valor | number_format }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else-if="taxas_disponiveis.length > 0">
                    <span>&nbsp;</span>
                    <p>Sem taxa escolhida</p>
                </div>
            </td>
            <td width="140" align="center">
                <button @click.prevent.stop="excluir" class="default-button red full" style="margin-bottom: 0.5em;"
                    v-if="pode_remover">
                    Remover
                </button>
                <router-link v-if="checklist" :to="`/reservas/checklist/${reserva.id}`"
                    class="default-button full">CHECKLIST</router-link>
            </td>
            <td width="140" align="center">

                <router-link :to="`/reservas/detalhes/${reserva.id}`" class="default-button">Informações</router-link>
            </td>
        </tr>
        <tr class="print">
            <td width="100">
                <strong>{{ reserva.data | date("dd/LL/yyyy") }}</strong>
            </td>
            <td>{{ reserva.ambiente.titulo }}</td>

            <td>{{ reserva.titulo_unidade }}</td>
            <td>
                <strong v-if="reserva.turno">
                    {{ reserva.turno.titulo }}
                </strong>


            </td>

        </tr>
        <tr v-if="taxas.length != 0" class="print taxa----">
            <td colspan="4" style="display:block">
                <table width="100%">
                    <thead>
                        <tr>
                            <th align="left">Taxa</th>
                            <th width="150">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="taxa in taxas">
                            <td>{{ taxa.titulo }}</td>
                            <td align="center">R$ {{ taxa.valor | number_format }}</td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        <tr v-else-if="taxas_disponiveis.length > 0" class="print">
            <td colspan="4" style="display:block">
                <span>&nbsp;</span>
                Sem taxa escolhida
            </td>
        </tr>
    </tbody>
</template>
<script>
import api from "/plugins/api";
import Swal from "sweetalert2";
import { DateTime } from 'luxon';

export default {
    props: ["reserva", "config_condominio"],
    data() {
        return {
            excluindo: false,
        };
    },
    computed: {
        taxas_disponiveis() {
            if (!this.ambiente || !this.ambiente?.configs?.taxas) {
                return []
            }
            const taxas = this.ambiente.configs.taxas || []
            return taxas
        },
        taxas() {
            if (!this.ambiente || !this.ambiente?.configs?.taxas) {
                return []
            }
            const taxas = this.ambiente.configs.taxas || []
            if (!this.reserva || !this.reserva.taxas_selecionadas) {
                return []
            }

            const result = this.reserva?.taxas_selecionadas?.map(taxa_id => {
                return taxas.find(taxa => taxa.id == taxa_id)
            }).filter(t => t)

            return result
        },
        checklist() {
            return this.$store.getters.controleAcesso.reserva.checkList || false

        },
        relacao() {
            return this.$store.getters.relacao;
        },
        tipoRelacao() {
            return this.relacao.tipoRelacao;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        isSindico() {
            return this.tipoRelacao == "S";
        },
        cliente() {
            return this.$store.state.cliente;
        },
        ambiente() {
            return this.reserva?.ambiente
        },
        dias_limite_cancelamento() {
            // se configurado no ambiente e diferente de zero
            if (this.ambiente?.configs && this.ambiente?.configs.dias_limite_cancelamento) {
                return this.ambiente.configs.dias_limite_cancelamento;
            }

            // se não achar configuração de condominio nem de ambiente
            if (!this.config_condominio && !this.ambiene.configs) {
                return 0;
            }

            // valor configurado no condomínio
            return this.config_condominio.dias_limite_cancelamento | 0;
        },
        data_limite_cancelamento() {
            let { data } = this.reserva;
            const dias_limite_cancelamento = +this.dias_limite_cancelamento;

            let data_limit = DateTime.fromSQL(data).minus({ days: dias_limite_cancelamento }).toFormat('yyyy-LL-dd');
            return data_limit;
        },
        pode_remover() {
            if (this.isSindico) {
                return true;
            }
            if (this.reserva.codigo_cliente != this.cliente.codigo) {
                //return false;
            }


            if (!this.$store.getters.controleAcesso?.reserva?.cancelamento) {
                return false
            }
            
            const hoje = DateTime.now().toFormat('yyyy-LL-dd');
            const data_limite_cancelamento = this.data_limite_cancelamento;
            return data_limite_cancelamento >= hoje;
        },
    },
    methods: {
        async excluir() {
            try {
                let response = await Swal.fire({
                    icon: "warning",
                    title: "Deseja remover a reserva?",
                    text: "Esta é uma operação irreversível, deseja continuar?",
                    showCancelButton: true,
                });
                if (!response.isConfirmed) {
                    return;
                }

                this.excluindo = true;
                let { data } = await api.delete(`reservas/${this.reserva.id}`);

                this.$emit("remove", this.reserva.id);
            } catch (err) {
                if (err.response && err.response.data) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: err.response.data.error,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: "Não foi possível excluir a reserva.",
                    });
                    console.error(err);
                }
            }
            this.excluindo = false;
        },
    },
};
</script>